<template>
  <v-app class="landing-app">
    <!-- Navigation Bar -->
    <Navbar />

    <!-- Page Views Container -->
    <v-main class="landing-main">
      <router-view />
    </v-main>

    <!-- Footer -->
    <Footer />
  </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue';
import Footer from '../components/Footer.vue';
import '../landingpage.css';

export default {
  name: 'MainLayout',
  components: {
    Navbar,
    Footer
  }
};
</script>

<style scoped>
.landing-app {
  background-color: var(--bg-main) !important;
}
.landing-main {
  padding-top: 0 !important;
}
</style>
